<template>
    <v-autocomplete
        v-model="model"
        :items="users"
        item-text="full_name"
        item-value="id"
        :loading="isLoading"
        :search-input.sync="search"
        :label=label
        :placeholder=placeholder
        :clearable="clearable"
        :class="className"
        chips
        dense
    >
    </v-autocomplete>
</template>

<script>
import RequestList from '../services/RequestList';
import UsersService from '../services/UsersService'

export default {
    props : ['value', 'label', 'placeholder','clearable', 'className'],
    data: () => ({
        model: null,
        users : [],
        isLoading: false,
        search: null,
        searchHandler : null
    }),

    computed: {
    },

    watch: {
        model(value){
            this.$emit('input', value);
        },
        search(str){
            if(this.searchHandler){
                clearTimeout(this.searchHandler);
            }

            if(!str){
                this.users = []
                return;
            }

            if( str.length <= 3 ){
                return;
            }

            let isMobile = !isNaN(str);
            
            this.searchHandler = setTimeout( () => {
                let searchFilter = {
                    column_name : isMobile ? 'mobile' : 'full_name',
                    operand : 'Contains',
                    value : str
                };
                this.searchHandler = null;

                let requestList = new RequestList();

                requestList.addOrder('id','desc');
                requestList.setPage(1,10);
                requestList.addFilter(searchFilter.column_name, searchFilter.operand, searchFilter.value);

                this.isLoading = true;

                UsersService.compactList(requestList)
                .then( response => {
                    this.users = response.data.value.users;
                })
                .finally(()=>{
                    this.isLoading = false;
                });
            }, 1000);
        },
    },
}
</script>